import Card from "@/components/common/Card";
import FormField from "@/components/common/FormField";
import MainHeading from "@/components/common/MainHeading";
import Layout from "@/components/layout/Layout";


const CreateCompany: React.FC = () => {

    return (
        <Layout>
            <div className='space-y-6'>
                <MainHeading
                    title='Add Company'
                />
                <Card>
                    <div className="grid grid-cols-2 gap-4">
                        <FormField
                            label="Company Name"
                            type="text"
                            placeholder="Company Name"
                            name="companyName"
                        />
                        <FormField
                            label="Company Code"
                            type="text"
                            placeholder="Company Code"
                            name="companyCode"
                        />
                        <FormField
                            label="Company Type"
                            type="select"
                            placeholder="Company Type"
                            name="companyType"
                            options={[
                                { label: "Office", value: "office" },
                                { label: "Site", value: "site" }
                            ]}
                        />
                        <FormField
                            label="Email"
                            type="email"
                            placeholder="Email"
                            name="email"
                        />
                        <FormField
                            label="Phone Number"
                            type="number"
                            placeholder="Phone Number"
                            name="phoneNumber"
                        />
                        <FormField
                            label="Address"
                            type="text"
                            placeholder="Address"
                            name="address"
                        />
                        <FormField
                            label="Country"
                            type="select"
                            placeholder="Country"
                            name="country"
                            options={[
                                { label: "India", value: "india" },
                                { label: "USA", value: "usa" }
                            ]}
                        />
                        <FormField
                            label="State"
                            type="select"
                            placeholder="State"
                            name="state"
                            options={[
                                { label: "Madhya Pradesh", value: "madhya pradesh" },
                                { label: "New York", value: "new york" }
                            ]}
                        />
                        <FormField
                            label="City"
                            type="select"
                            placeholder="City"
                            name="city"
                            options={[
                                { label: "Indore", value: "indore" },
                                { label: "New York", value: "new york" }
                            ]}
                        />
                        <FormField
                            label="Pincode"
                            type="number"
                            placeholder="Pincode"
                            name="pincode"
                        />
                        <FormField
                            label="Search Location"
                            type="text"
                            placeholder="Search Location"
                            name="searchLocation"
                        />
                        <FormField
                            label="Allowed Range"
                            type="number"
                            placeholder="Allowed Range"
                            name="allowedRange"
                        />
                        <FormField
                            label="Branch ID"
                            type="text"
                            placeholder="Branch ID"
                            name="branchId"
                        />
                        <FormField
                            label="Is Punch Allowed"
                            type="radio"
                            placeholder="Is Punch Allowed"
                            name="isPunchAllowed"
                            options={[
                                { label: "Yes", value: "yes" },
                                { label: "No", value: "no" }
                            ]}
                        />
                        <FormField
                            label="Status"
                            type="radio"
                            placeholder="Status"
                            name="status"
                            options={[
                                { label: "Active", value: "active" },
                                { label: "Inactive", value: "inactive" }
                            ]}
                        />
                    </div>
                </Card>
            </div>
        </Layout>
    )
}

export default CreateCompany